module.exports = __webpack_public_path__ + "img/wechat_icon.fc15b8cb.png";